"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconMap = void 0;
var Components = __importStar(require("./"));
exports.IconMap = {
    abdominalMeasuresFilled: Components.AbdominalMeasuresFilled,
    abdominalMeasuresOutline: Components.AbdominalMeasuresOutline,
    addProfessionalFilled: Components.AddProfessionalFilled,
    addProfessionalOutline: Components.AddProfessionalOutline,
    adjust: Components.Adjust,
    adverseReactionFilled: Components.AdverseReactionFilled,
    adverseReactionOutline: Components.AdverseReactionOutline,
    agile: Components.Agile,
    alignCenter: Components.AlignCenter,
    alignJustify: Components.AlignJustify,
    alignLeft: Components.AlignLeft,
    alignRight: Components.AlignRight,
    angleDoubleLeft: Components.AngleDoubleLeft,
    angleDoubleRight: Components.AngleDoubleRight,
    angleDown: Components.AngleDown,
    angleLeft: Components.AngleLeft,
    angleRight: Components.AngleRight,
    angleUp: Components.AngleUp,
    appleFilled: Components.AppleFilled,
    appleOutline: Components.AppleOutline,
    archiveFilled: Components.ArchiveFilled,
    archiveOutline: Components.ArchiveOutline,
    arrowDown: Components.ArrowDown,
    arrowLeft: Components.ArrowLeft,
    arrowRight: Components.ArrowRight,
    arrowUp: Components.ArrowUp,
    babyTreeFilled: Components.BabyTreeFilled,
    babyTreeOutline: Components.BabyTreeOutline,
    backlogSplit: Components.BacklogSplit,
    backpackFilled: Components.BackpackFilled,
    backpackOutline: Components.BackpackOutline,
    bag: Components.Bag,
    balanceFilled: Components.BalanceFilled,
    balanceOutline: Components.BalanceOutline,
    balancePlus: Components.BalancePlus,
    bandaidFilled: Components.BandaidFilled,
    bandaidOutline: Components.BandaidOutline,
    banFilled: Components.BanFilled,
    banOutline: Components.BanOutline,
    batteryFull: Components.BatteryFull,
    batteryLow: Components.BatteryLow,
    batteryMedium: Components.BatteryMedium,
    beach: Components.Beach,
    beerGlasFilled: Components.BeerGlasFilled,
    beerGlassFilled: Components.BeerGlassFilled,
    beerGlassOutline: Components.BeerGlassOutline,
    bellFilled: Components.BellFilled,
    bellOutline: Components.BellOutline,
    bike: Components.Bike,
    birthdayCakeFilled: Components.BirthdayCakeFilled,
    birthdayCakeOutline: Components.BirthdayCakeOutline,
    bloodPressureFilled: Components.BloodPressureFilled,
    bloodPressureOutline: Components.BloodPressureOutline,
    bold: Components.Bold,
    bookmarkFilled: Components.BookmarkFilled,
    bookmarkOutline: Components.BookmarkOutline,
    boxFilled: Components.BoxFilled,
    boxOutline: Components.BoxOutline,
    braille: Components.Braille,
    brainFilled: Components.BrainFilled,
    brainOutline: Components.BrainOutline,
    bricksFilled: Components.BricksFilled,
    bricksOutline: Components.BricksOutline,
    bridge: Components.Bridge,
    brush: Components.Brush,
    bugFilled: Components.BugFilled,
    bugOutline: Components.BugOutline,
    building: Components.Building,
    busFilled: Components.BusFilled,
    busOutline: Components.BusOutline,
    calendarAddFilled: Components.CalendarAddFilled,
    calendarAddOutline: Components.CalendarAddOutline,
    calendarFilled: Components.CalendarFilled,
    calendarOutline: Components.CalendarOutline,
    calendarWithDropFilled: Components.CalendarWithDropFilled,
    calendarWithDropOutline: Components.CalendarWithDropOutline,
    calfMeasuaresFilled: Components.CalfMeasuaresFilled,
    calfMeasuaresOutline: Components.CalfMeasuaresOutline,
    cameraFilled: Components.CameraFilled,
    cameraOutline: Components.CameraOutline,
    candle: Components.Candle,
    chatFilled: Components.ChatFilled,
    chatOutline: Components.ChatOutline,
    chatViewFilled: Components.ChatViewFilled,
    chatViewOutline: Components.ChatViewOutline,
    checkCircleFilled: Components.CheckCircleFilled,
    checkCircleOutline: Components.CheckCircleOutline,
    checkDefault: Components.CheckDefault,
    checklistFilled: Components.ChecklistFilled,
    checklistOutline: Components.ChecklistOutline,
    cherryFilled: Components.CherryFilled,
    cherryOutline: Components.CherryOutline,
    clearFormat: Components.ClearFormat,
    clip: Components.Clip,
    clockArrowFilled: Components.ClockArrowFilled,
    clockArrowOutline: Components.ClockArrowOutline,
    clockFilled: Components.ClockFilled,
    clockOutline: Components.ClockOutline,
    cloudFilled: Components.CloudFilled,
    cloudOutline: Components.CloudOutline,
    clownFaceFilled: Components.ClownFaceFilled,
    clownFaceOutline: Components.ClownFaceOutline,
    code: Components.Code,
    continuousMedicine: Components.ContinuousMedicine,
    contrast: Components.Contrast,
    contrastActive: Components.ContrastActive,
    cookieFilled: Components.CookieFilled,
    cookieOutline: Components.CookieOutline,
    copyFilled: Components.CopyFilled,
    copyOutline: Components.CopyOutline,
    creditCardFilled: Components.CreditCardFilled,
    creditCardOutline: Components.CreditCardOutline,
    crossFilled: Components.CrossFilled,
    crossOutline: Components.CrossOutline,
    cutleryFilled: Components.CutleryFilled,
    cutleryOutline: Components.CutleryOutline,
    dataCheckFilled: Components.DataCheckFilled,
    dataCheckOutline: Components.DataCheckOutline,
    dataFilled: Components.DataFilled,
    dataOutline: Components.DataOutline,
    deaf: Components.Deaf,
    decreaseFont: Components.DecreaseFont,
    desktopFilled: Components.DesktopFilled,
    desktopOutline: Components.DesktopOutline,
    devicesFilled: Components.DevicesFilled,
    devicesOutline: Components.DevicesOutline,
    dogLeashed: Components.DogLeashed,
    dots: Components.Dots,
    download: Components.Download,
    dragdrop: Components.Dragdrop,
    dropFilled: Components.DropFilled,
    dropOutline: Components.DropOutline,
    dumbbellFilled: Components.DumbbellFilled,
    dumbbellOutline: Components.DumbbellOutline,
    edema: Components.Edema,
    emailFilled: Components.EmailFilled,
    emailOutline: Components.EmailOutline,
    exchange: Components.Exchange,
    exclamationDefault: Components.ExclamationDefault,
    exclamationTriangleFilled: Components.ExclamationTriangleFilled,
    exclamationTriangleOutline: Components.ExclamationTriangleOutline,
    expand: Components.Expand,
    eyeFilled: Components.EyeFilled,
    eyeHiddenFilled: Components.EyeHiddenFilled,
    eyeHiddenOutline: Components.EyeHiddenOutline,
    eyeOutline: Components.EyeOutline,
    f5: Components.F5,
    faqFilled: Components.FaqFilled,
    faqOutline: Components.FaqOutline,
    faucetFilled: Components.FaucetFilled,
    faucetOutline: Components.FaucetOutline,
    fence: Components.Fence,
    fileEmptyFilled: Components.FileEmptyFilled,
    fileEmptyOutline: Components.FileEmptyOutline,
    fileVisualizationFilled: Components.FileVisualizationFilled,
    fileVisualizationOutline: Components.FileVisualizationOutline,
    fileWithItemsFilled: Components.FileWithItemsFilled,
    fileWithItemsOutline: Components.FileWithItemsOutline,
    filterFilled: Components.FilterFilled,
    filterOutline: Components.FilterOutline,
    flexedBicepsFilled: Components.FlexedBicepsFilled,
    floorPlan: Components.FloorPlan,
    flowchart: Components.Flowchart,
    folderFilled: Components.FolderFilled,
    folderOutline: Components.FolderOutline,
    fundalHeightFilled: Components.FundalHeightFilled,
    fundalHeightOutline: Components.FundalHeightOutline,
    gantt: Components.Gantt,
    gearFilled: Components.GearFilled,
    gearOutline: Components.GearOutline,
    glucometer: Components.Glucometer,
    graduateCap: Components.GraduateCap,
    grimacingFaceFilled: Components.GrimacingFaceFilled,
    grimacingFaceOutline: Components.GrimacingFaceOutline,
    grownTreeFilled: Components.GrownTreeFilled,
    grownTreeOutline: Components.GrownTreeOutline,
    hairDryerFilled: Components.HairDryerFilled,
    hairDryerOutline: Components.HairDryerOutline,
    hamburguerMenu: Components.HamburguerMenu,
    headMeasuresFilled: Components.HeadMeasuresFilled,
    headMeasuresOutline: Components.HeadMeasuresOutline,
    headset: Components.Headset,
    healthSystemFilled: Components.HealthSystemFilled,
    healthSystemOutline: Components.HealthSystemOutline,
    hear: Components.Hear,
    heartFilled: Components.HeartFilled,
    heartOutline: Components.HeartOutline,
    heartRateFilled: Components.HeartRateFilled,
    heartRateOutline: Components.HeartRateOutline,
    hierarchy: Components.Hierarchy,
    highFiveFilled: Components.HighFiveFilled,
    highVoltageFilled: Components.HighVoltageFilled,
    highVoltageOutline: Components.HighVoltageOutline,
    hiking: Components.Hiking,
    horus: Components.Horus,
    hospital: Components.Hospital,
    houseFilled: Components.HouseFilled,
    houseOutline: Components.HouseOutline,
    imageFilled: Components.ImageFilled,
    imageOutline: Components.ImageOutline,
    imcFilled: Components.ImcFilled,
    inboxFilled: Components.InboxFilled,
    inboxOutline: Components.InboxOutline,
    increaseFont: Components.IncreaseFont,
    infoCircleFilled: Components.InfoCircleFilled,
    infoCircleOutline: Components.InfoCircleOutline,
    infoDefault: Components.InfoDefault,
    italic: Components.Italic,
    kanbanFilled: Components.KanbanFilled,
    kanbanOutline: Components.KanbanOutline,
    keyFilled: Components.KeyFilled,
    keyOutline: Components.KeyOutline,
    labBeakerFilled: Components.LabBeakerFilled,
    labBeakerOutline: Components.LabBeakerOutline,
    leafFilled: Components.LeafFilled,
    leafOutline: Components.LeafOutline,
    lightbulbFilled: Components.LightbulbFilled,
    lightbulbOutline: Components.LightbulbOutline,
    link: Components.Link,
    list: Components.List,
    loading: Components.Loading,
    lockCloseFilled: Components.LockCloseFilled,
    lockCloseOutline: Components.LockCloseOutline,
    lockOpenFilled: Components.LockOpenFilled,
    lockOpenOutline: Components.LockOpenOutline,
    lungs: Components.Lungs,
    mapFilled: Components.MapFilled,
    mapMarkerFilled: Components.MapMarkerFilled,
    mapMarkerOutline: Components.MapMarkerOutline,
    mapOutline: Components.MapOutline,
    medalFilled: Components.MedalFilled,
    medalOutline: Components.MedalOutline,
    medicalCrossFilled: Components.MedicalCrossFilled,
    medicalCrossOutline: Components.MedicalCrossOutline,
    medicineBottleFilled: Components.MedicineBottleFilled,
    medicineBottleOutline: Components.MedicineBottleOutline,
    medicineExclamation: Components.MedicineExclamation,
    microphoneFilled: Components.MicrophoneFilled,
    microphoneOffFilled: Components.MicrophoneOffFilled,
    microphoneOffOutline: Components.MicrophoneOffOutline,
    microphoneOutline: Components.MicrophoneOutline,
    minimize: Components.Minimize,
    minus: Components.Minus,
    minusCircleFilled: Components.MinusCircleFilled,
    minusCircleOutline: Components.MinusCircleOutline,
    module: Components.Module,
    monitorFilled: Components.MonitorFilled,
    monitorOutline: Components.MonitorOutline,
    moonFilled: Components.MoonFilled,
    moonOutline: Components.MoonOutline,
    mosquito: Components.Mosquito,
    motocycle: Components.Motocycle,
    mugFilled: Components.MugFilled,
    mugOutline: Components.MugOutline,
    multipleUsers: Components.MultipleUsers,
    multipleUsersOutline: Components.MultipleUsersOutline,
    mushroom: Components.Mushroom,
    needleFilled: Components.NeedleFilled,
    needleOutline: Components.NeedleOutline,
    noDataFilled: Components.NoDataFilled,
    noDataOutline: Components.NoDataOutline,
    nurse: Components.Nurse,
    nurseView: Components.NurseView,
    o2Filled: Components.O2Filled,
    officeChair: Components.OfficeChair,
    openBookFilled: Components.OpenBookFilled,
    openBookOutline: Components.OpenBookOutline,
    openDoor: Components.OpenDoor,
    openInNewTabFilled: Components.OpenInNewTabFilled,
    openInNewTabOutline: Components.OpenInNewTabOutline,
    paintBucket: Components.PaintBucket,
    path: Components.Path,
    pause: Components.Pause,
    penFilled: Components.PenFilled,
    penOutline: Components.PenOutline,
    penTool: Components.PenTool,
    personExercising: Components.PersonExercising,
    personWithLaptop: Components.PersonWithLaptop,
    pessoaComDeficiencia: Components.PessoaComDeficiencia,
    petFilled: Components.PetFilled,
    petOutline: Components.PetOutline,
    phoneFilled: Components.PhoneFilled,
    phoneOutline: Components.PhoneOutline,
    pictureInPictureFilled: Components.PictureInPictureFilled,
    pictureInPictureOutline: Components.PictureInPictureOutline,
    pillFilled: Components.PillFilled,
    pillOutline: Components.PillOutline,
    pinFilled: Components.PinFilled,
    pinOutline: Components.PinOutline,
    pipeFilled: Components.PipeFilled,
    pipeOutline: Components.PipeOutline,
    plantFilled: Components.PlantFilled,
    plantOutline: Components.PlantOutline,
    plateFilled: Components.PlateFilled,
    plateOutline: Components.PlateOutline,
    playFilled: Components.PlayFilled,
    playOutline: Components.PlayOutline,
    plus: Components.Plus,
    plusCircleFilled: Components.PlusCircleFilled,
    plusCircleOutline: Components.PlusCircleOutline,
    policeBadge: Components.PoliceBadge,
    pollFilled: Components.PollFilled,
    pollOutline: Components.PollOutline,
    pregnant: Components.Pregnant,
    presentationFilled: Components.PresentationFilled,
    presentationOutline: Components.PresentationOutline,
    priceTagReal: Components.PriceTagReal,
    printerFilled: Components.PrinterFilled,
    printerOutline: Components.PrinterOutline,
    prison: Components.Prison,
    professionalChatFilled: Components.ProfessionalChatFilled,
    professionalChatOutline: Components.ProfessionalChatOutline,
    puzzle: Components.Puzzle,
    qrCode: Components.QrCode,
    questionMarkFilled: Components.QuestionMarkFilled,
    questionMarkOutline: Components.QuestionMarkOutline,
    quoteLeft: Components.QuoteLeft,
    quoteRight: Components.QuoteRight,
    redo: Components.Redo,
    roadFilled: Components.RoadFilled,
    roadOutline: Components.RoadOutline,
    rocket: Components.Rocket,
    rollerBrushFilled: Components.RollerBrushFilled,
    rollerBrushOutline: Components.RollerBrushOutline,
    rulerFilled: Components.RulerFilled,
    rulerOutline: Components.RulerOutline,
    scooter: Components.Scooter,
    screenShareFilled: Components.ScreenShareFilled,
    screenShareOutline: Components.ScreenShareOutline,
    seedBagFilled: Components.SeedBagFilled,
    seedBagOutline: Components.SeedBagOutline,
    seedFilled: Components.SeedFilled,
    seedOutline: Components.SeedOutline,
    sendFilled: Components.SendFilled,
    sendOutline: Components.SendOutline,
    shieldFilled: Components.ShieldFilled,
    shieldOutline: Components.ShieldOutline,
    shoppingCartFilled: Components.ShoppingCartFilled,
    shoppingCartOutline: Components.ShoppingCartOutline,
    signLanguage: Components.SignLanguage,
    signOut: Components.SignOut,
    sixtyPlus: Components.SixtyPlus,
    skate: Components.Skate,
    smileFaceFilled: Components.SmileFaceFilled,
    smileFaceOutline: Components.SmileFaceOutline,
    sneakerFilled: Components.SneakerFilled,
    sneakerOutline: Components.SneakerOutline,
    soccerOutline: Components.SoccerOutline,
    sort: Components.Sort,
    sparkles: Components.Sparkles,
    sproutFilled: Components.SproutFilled,
    sproutOutline: Components.SproutOutline,
    stampFilled: Components.StampFilled,
    stampOutline: Components.StampOutline,
    starFilled: Components.StarFilled,
    starOutline: Components.StarOutline,
    stethoscopeFilled: Components.StethoscopeFilled,
    stethoscopeOutline: Components.StethoscopeOutline,
    stopFilled: Components.StopFilled,
    stopOutline: Components.StopOutline,
    strikethrough: Components.Strikethrough,
    strollerFilled: Components.StrollerFilled,
    strollerOutline: Components.StrollerOutline,
    sunFilled: Components.SunFilled,
    sunOutline: Components.SunOutline,
    sunrise: Components.Sunrise,
    surfFilled: Components.SurfFilled,
    surfOutline: Components.SurfOutline,
    sync: Components.Sync,
    target: Components.Target,
    teddyBear: Components.TeddyBear,
    telescopeFilled: Components.TelescopeFilled,
    telescopeOutline: Components.TelescopeOutline,
    tennisFilled: Components.TennisFilled,
    tennisOutline: Components.TennisOutline,
    thermometerFilled: Components.ThermometerFilled,
    thermometerOutline: Components.ThermometerOutline,
    thoughtFilled: Components.ThoughtFilled,
    thoughtOutline: Components.ThoughtOutline,
    timerFilled: Components.TimerFilled,
    timerOutline: Components.TimerOutline,
    timesDefault: Components.TimesDefault,
    timesFilled: Components.TimesFilled,
    timesOutline: Components.TimesOutline,
    toothFilled: Components.ToothFilled,
    toothOutline: Components.ToothOutline,
    translate: Components.Translate,
    trashFilled: Components.TrashFilled,
    trashOutline: Components.TrashOutline,
    tShirtFilled: Components.TShirtFilled,
    tShirtOutline: Components.TShirtOutline,
    underline: Components.Underline,
    undo: Components.Undo,
    universalAccess: Components.UniversalAccess,
    upload: Components.Upload,
    userBan: Components.UserBan,
    userCardFilled: Components.UserCardFilled,
    userCardOutline: Components.UserCardOutline,
    userCheck: Components.UserCheck,
    userFilled: Components.UserFilled,
    userForwardFilled: Components.UserForwardFilled,
    userForwardOutline: Components.UserForwardOutline,
    userOutline: Components.UserOutline,
    userReturn: Components.UserReturn,
    userSearch: Components.UserSearch,
    userTimes: Components.UserTimes,
    userWarning: Components.UserWarning,
    videoOffFilled: Components.VideoOffFilled,
    videoOffOutline: Components.VideoOffOutline,
    videoOnFilled: Components.VideoOnFilled,
    videoOnOutline: Components.VideoOnOutline,
    volleyFilled: Components.VolleyFilled,
    volleyOutline: Components.VolleyOutline,
    volumeFilled: Components.VolumeFilled,
    volumeMuteFilled: Components.VolumeMuteFilled,
    volumeMuteOutline: Components.VolumeMuteOutline,
    volumeOutline: Components.VolumeOutline,
    walk: Components.Walk,
    walker: Components.Walker,
    walletFilled: Components.WalletFilled,
    walletOutline: Components.WalletOutline,
    wheelchair: Components.Wheelchair,
    wifi: Components.Wifi,
    winkFaceFilled: Components.WinkFaceFilled,
    winkFaceOutline: Components.WinkFaceOutline,
    xp: Components.Xp,
    zoomMinusFilled: Components.ZoomMinusFilled,
    zoomMinusOutline: Components.ZoomMinusOutline,
    zoomOutline: Components.ZoomOutline,
    zoomPlusFilled: Components.ZoomPlusFilled,
    zoomPlusOutline: Components.ZoomPlusOutline,
};
//# sourceMappingURL=types.js.map